import { Router } from '@angular/router';
import { GridAction } from '@eforall/dashboard';
import { Accelerator } from '@interfaces';

export function getActions(router: Router) {

	const actions: GridAction<Accelerator>[] = [
		{
			iconClass: 'fa-regular fa-file-lines',
			label: 'Open Accelerator',
			isEnabled: rows => !!rows.length,
			execute: async rows => {
				router.navigate(['/delivery/accelerators', rows[0]?.name]);
			}
		},
	];

	return actions;
}